export default{sources:{avif:"__VITE_ASSET__CF$jWVms__ 262w",webp:"__VITE_ASSET__DHn6GA2k__ 262w"},img:{src:"__VITE_ASSET__BI01Uto4__",w:262,h:300}};